module.exports = require("./de-CH.d.ts");